import type { IconSvgObject } from './types';

const CollapseIcon: IconSvgObject = [
  ["path", { d: "M13 4L13.0001 10C13.0001 10.5523 13.4478 11 14.0001 11L20 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 20L10.9999 14C10.9999 13.4477 10.5522 13 9.99994 13L4 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CollapseIcon;
